export const DEFAULT_LANGUAGE = "en-uk";
export const DEFAULT_LANGUAGE_LABEL = "EN-UK";
export const EN_US_CODE = "en-us";
